import ComparativeBuildingsSummary from './ComparativeBuildingsSummary';
import ComparativeBuildingSummary from './ComparativeBuildingSummary';
import ComparativeDwellingSummary from './ComparativeDwellingSummary';
import ComparativeInsuredInformationSummary from './ComparativeInsuredInformationSummary';
import ComparativeMortgageesSummary from './ComparativeMortgageesSummary';
import ComparativeMortgageeSummary from './ComparativeMortgageeSummary';
import ComparativePerilsDeductiblesSummary from './ComparativePerilsDeductiblesSummary';
import ComparativePolicyCostSummary from './ComparativePolicyCostSummary';
import ComparativePolicyInformationSummary from './ComparativePolicyInformationSummary';
import ComparativePublicBuildingsSummary from './ComparativePublicBuildingsSummary';
import ComparativePublicBuildingSummary from './ComparativePublicBuildingSummary';
import ComparativePublicDwellingSummary from './ComparativePublicDwellingSummary';

export {
	ComparativeBuildingsSummary,
	ComparativeBuildingSummary,
	ComparativeDwellingSummary,
	ComparativeInsuredInformationSummary,
	ComparativeMortgageesSummary,
	ComparativeMortgageeSummary,
	ComparativePerilsDeductiblesSummary,
	ComparativePolicyCostSummary,
	ComparativePolicyInformationSummary,
	ComparativePublicBuildingsSummary,
	ComparativePublicBuildingSummary,
	ComparativePublicDwellingSummary,
}